import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';

type Props = {
  isAuthenticated: boolean;
};

const AuthenticatedRoute = ({isAuthenticated}: Props) => {
    return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default AuthenticatedRoute;
